import React, { useEffect, useState } from 'react';

import styles from 'prequalificationV2/pages/Dashboard/AcceptedOfferDetails/OffersDetails/OffersDetails.module.scss';
import FormBody from 'components/FormBody/index';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { LoadingType } from 'prequalificationV2/actions/index';
import Loader from 'components/Loader/index';
import { Lender } from 'enums/ApplicationsVariables';
import { QUILO_FIXED_RATE_DESCRIPTION } from 'prequalificationV2/pages/Dashboard/steps/AcceptOffer/acceptOffer.constants';
import LoanOfferCard from 'prequalificationV2/pages/Dashboard/steps/AcceptOffer/ManualOffers/AcceptOneTermOffer/LoanOfferCard/LoanOfferCard';
import LoanOfferOptions from 'prequalificationV2/pages/Dashboard/steps/AcceptOffer/ManualOffers/AcceptOneTermOffer/LoanOfferOptions/LoanOfferOptions';
import { OfferDto, offersApi } from 'api/OffersApi';
import * as notificationManager from 'notifications';
import { FailureNotificationType } from 'notifications';

const OffersDetails = () => {
  const { applicationId } = useAppSelector((state) => state.application);
  const isGlobalLoading = useAppSelector((state) => state.loading[LoadingType.DashboardPageUpdating]);
  const [loanOffers, setLoanOffers] = useState<OfferDto[]>([]);
  const [isAnyLenderQuilo, setIsAnyLenderQuilo] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getLoans = async () => {
      try {
        setIsLoading(true);

        const offersResponse = await offersApi.getOneTermOffers(applicationId!);

        setLoanOffers(offersResponse);
        setIsAnyLenderQuilo(offersResponse.map((offer) => offer.lender).includes(Lender.Quilo));
      } catch (error) {
        notificationManager.notifyFailure(FailureNotificationType.UnknownError);
      } finally {
        setIsLoading(false);
      }
    };

    getLoans();
  }, [applicationId]);

  return isLoading || isGlobalLoading ? (
    <Loader />
  ) : (
    <>
      <div className={styles.acceptOfferContainer}>
        {loanOffers && (
          <FormBody formBodyClassName={styles.formBody}>
            <div className={styles.offerCards}>
              {loanOffers.map((loanOffer, index) => {
                return (
                  <LoanOfferCard
                    key={index}
                    title={loanOffers.length > 1 ? `Loan ${index + 1}` : ``}
                    loanOffer={loanOffer}
                    lender={''}
                  />
                );
              })}
              <LoanOfferOptions />
            </div>
            {isAnyLenderQuilo && <div className={styles.fixedRateDescription}>{QUILO_FIXED_RATE_DESCRIPTION}</div>}
          </FormBody>
        )}
      </div>
    </>
  );
};

export default OffersDetails;
